export default {"src":"/_next/static/media/cloud-white.8ebef231.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};